import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = { class: "contentBox" }
const _hoisted_3 = { class: "block w-full" }
const _hoisted_4 = { class: "flex mb-4" }
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon-neu" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["disabled", "title"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon-loeschen" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ml-auto" }
const _hoisted_12 = { class: "text-center" }

import {useSystemStore} from "@/stores/system/SystemStore";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import GridInputFilter from "@/components/system/GridInputFilter.vue";
import {checkboxColumnConfig, defaultSpaceAroundTableOnPage} from "@/AppConfig";
import {onBeforeUnmount, onMounted, reactive, ref} from "vue";
import {useI18n} from "vue-i18n";
import {Menu, Grid, Store, StringHelper} from "@bryntum/grid";
import dialog from "@/components/system/dialog";
import {ErrorLocationType, PopupType, TableType} from "@/utilities/system/enums/Enums";
import router from "@/router";
import {ProviderService} from "@/utilities/services/entities/ProviderService";
import {Provider} from "@/models/entities/providers/Provider";
import {useProviderStore} from "@/stores/ProviderStore";
import Error from "@/components/system/Error.vue";
import LoadingSpinner from "@/components/system/LoadingSpinner.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProviderManagment',
  setup(__props) {

const gridStore = new Store();
const systemStore = useSystemStore();

let selectedProviders = ref([]);

const { t } = useI18n();
const providerService = new ProviderService();
const providerStore = useProviderStore();

const currentWindowHeight = ref("");
const recalcGridHeight = () => {
  currentWindowHeight.value = `${window.innerHeight-defaultSpaceAroundTableOnPage}px`;
};

const deleteSelection = async() => {
  //drop call without selection
  if(!selectedProviders.value?.some(()=>true)) return;

  const answer = await dialog
      .okText(t("global.delete"))
      .cancelText(t("global.cancel"))
      .confirm(t("providerManagement.confirmDeletionMulti", { count:selectedProviders.value.length}));

  if (answer) {
    let someEntriesFailed = false;
    for (const p of selectedProviders.value){
      const resp = await providerService.deleteSystemConnectionToProvider(p.id, ErrorLocationType.table);
      if(!resp){
        someEntriesFailed = true;
        continue;
      }

      gridStore.applyChangeset({removed:[{id:p.id}]});
    }

    if (someEntriesFailed) return;

    systemStore.showSuccess(t("global.deleted"));
  }
};

const grid = ref<{instance:{value:Grid}}|null>(null);
const useGridConfig = {
  headerMenuFeature: false,
  cellTooltipFeature: {
    hoverDelay      : 300,
    textContent     : true,
    hideOnDelegateChange: true,
  },
  relayStoreEvents: true,
  enableTextSelection: false,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  },
  columns : {
    data: [

      {
        id:'name',
        field: 'name',
        text: t('providerManagement.grid.companyName'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          return StringHelper.xss`${value ?? ""}`;
        }
      },
      {
        id:'info',
        field: 'info',
        text: "",
        width: 60,
        sortable: false,
        resizable: false,
        minWidth: 60,
        type: "template",
        tooltipRenderer : ({record}:any) => {
          if(record.data.info == null || record.data.info == '') {
            return ""
          } else {
            return StringHelper.xss`${record.data.info}`
          }
        },
        template: ({record}:any) => {
          if(record.data.info == '' || record.data.info == null) {
            return "";
          } else {
            return `<div class="gridTooltipButton"><span class="icon-info text-blue"></span></div>`;
          }
        },
      },
      {
        id:'address',
        field: 'address',
        text: t('providerManagement.grid.adress'),
        flex: 2,
        type: "template",
        template: ({value}:any) => {
          return StringHelper.xss`${value ?? ""}`;
        }
      },
      {
        id:'statistic.pendingWorkerAssignments',
        field: 'statistic.pendingWorkerAssignments',
        text: '',
        width   : 36,
        type: "template",
        template: () => {
            return `<div class="gridRowButton"><span class="icon-person"></span></div>`;
        },
      },
      {
        id:'menu',
        text	: '',
        width   : 36,
        type	: 'widget',
        align: "center",
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        widgets : [{
          type	 : 'button',
          width: 36,
          icon	 : 'icon-kontext_horizontal',
          onAction : ({ source: btn }:any) => {
            const menu = menuFactory(btn.cellInfo.record.data);
            menu.alignTo({ target: btn })
            menu.show();
          }
        }]
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await systemStore.saveUserColumnOrder(TableType[TableType.provider], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  listeners: {
    selectionChange(event:any) {
      if(event.selection.length > 0 && event.selection[0]?.data === undefined) return;
      selectedProviders.value = selectedProviders.value.concat(event.selected.map((pr:any) => pr.data))
      selectedProviders.value = selectedProviders.value.filter(p => !event.deselected.map((pr:any) => pr.data).some((pr:any) => p?.id === pr?.id));
    },
    datachange(){
      systemStore.currentItems = gridStore.count;
      systemStore.allItems = gridStore.getCount();
    },
    cellClick({column, record}:any) {
      if (column.data.field === 'statistic.pendingWorkerAssignments') {
        router.push(`/providers/${record.data.companyId ?? record.data.id}`)
      }
    },
  },
  height: currentWindowHeight,
}
const gridConfig = reactive(useGridConfig);

const menuFactory = (record:any) => {
  const menu = new Menu({
    anchor   : true,
    autoShow : true,
    items	: [
      {
        text: t("providerManagement.menu.showStaff"),
        cls: 'color',
        icon: 'icon-status_aktiv',
        weight: 100,
        onItem : ({ menu }:any) => {
          router.push({ path: `/providers/${menu.record.companyId ?? menu.record.id}` })
        }
      },
      {
        text: t("global.edit"),
        cls: 'color',
        icon: 'icon-editieren',
        weight: 100,
        onItem : ({ menu }:any) => {
          systemStore.openPopup({
            data: menu.record,
            action: providerStore.addOrUpdateProvider,
            resetButton:false,
            title:t("providerManagement.popups.edit"),
            type:PopupType.providerManagementEditPopup
          });
        }
      },
      {
        text   : t("global.delete"),
        cls	: 'color',
        icon: 'icon-loeschen',
        weight : 140,
        onItem: async ({ menu }:any) => {
          const answer = await dialog
              .okText(t("global.delete"))
              .cancelText(t("global.cancel"))
              .confirm(t("providerManagement.confirmDeletionSingle", {name: menu.record.name}));

          if (answer) {
            const resp = await providerService.deleteSystemConnectionToProvider(menu.record.id, ErrorLocationType.table);
            if(!resp) return

            gridStore.applyChangeset({removed:[{id:menu.record.id}]});

            systemStore.showSuccess(t('global.deleted'));
          }
        }
      }
    ],
  });

  //@ts-expect-error
  menu.setRecord(record);

  return menu;
};

const newProvider = () => {
  systemStore.openPopup({
    data: new Provider(),
    action: providerStore.addOrUpdateProvider,
    resetButton: false,
    title:t("providerManagement.popups.addOrUpdate.title.new"),
    type:PopupType.providerManagementEditPopup
  });
}

const setGridData = async ()=>{
  // start spinner
  systemStore.gridDataIsLoading = true;

  const companyResp = await providerService.getProviderDetails(ErrorLocationType.table);
  if (!companyResp) return

  //@ts-expect-error
  gridStore.setStoreData(companyResp.anAbCompaniesInfo);

  systemStore.reorderColumns(TableType[TableType.provider]); //TODO import

  // stop spinner
  systemStore.gridDataIsLoading = false;
};

onMounted(async () => {
  // calculate grid height and sub to window resize event
  recalcGridHeight();
  window.addEventListener('resize', recalcGridHeight);

  systemStore.setGridStore(ref(gridStore));
  systemStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  await setGridData();
});

onBeforeUnmount(()=>{
  window.removeEventListener('resize', recalcGridHeight);

  systemStore.setGridStore(null);
  systemStore.setGridColumnStore(null);

  systemStore.currentItems = 0;
  systemStore.allItems = 0;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("providerManagement.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(Error, {
          errorLoc: _unref(ErrorLocationType).table
        }, null, 8, ["errorLoc"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "primary mr-2",
              onClick: newProvider,
              title: _unref(t)('providerManagement.new'),
              id: "createNew"
            }, _hoisted_7, 8, _hoisted_5),
            _createElementVNode("button", {
              class: "primary mr-2",
              disabled: !_unref(selectedProviders).some(()=>true),
              onClick: deleteSelection,
              title: _unref(t)('global.delete'),
              id: "deleteSelection"
            }, _hoisted_10, 8, _hoisted_8),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(GridInputFilter, {
                gridStore: _unref(gridStore),
                hideFilterButton: true
              }, null, 8, ["gridStore"])
            ])
          ]),
          _createVNode(_unref(BryntumGrid), _mergeProps({
            ref_key: "grid",
            ref: grid
          }, gridConfig, { readOnly: true }), null, 16)
        ])
      ], 512), [
        [_vShow, !_unref(systemStore).gridDataIsLoading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_12, [
        _createVNode(LoadingSpinner)
      ], 512), [
        [_vShow, _unref(systemStore).gridDataIsLoading]
      ])
    ])
  ], 64))
}
}

})